import React from "react";
import {NameExceptionHandler} from "./NameException.js";
import {isFormElements} from "../FormElements.js"

/* "this" context refers to FormComponent instance */
export function FormInstanceHandler(o){
    if(isFormElements(o)){
        NameExceptionHandler(o.props.name);
        this.allNodes[o.props.name] = null;
        o = React.cloneElement(o, {
            _formElementStatuschange : (flag, name)=>{
                this.validatationOnChange(flag, name);
            },
            ref : (elem) => { this.allNodes[o.props.name] = elem } //Use the nodes ref for future use
        })
    }
    return o;
}
